// extracted by mini-css-extract-plugin
export default {"container":"NoOngoing_container__STu2Y","box":"NoOngoing_box__MM33U","noOngoingImg":"NoOngoing_noOngoingImg__J-MX2","noOngoingText":"NoOngoing_noOngoingText__tEqR7"};